
import { isBefore, parseISO } from 'date-fns'

export default {
    props: {
        model: {
            type: Object,
            default: () => {
                return {}
            },
        },
    },

    data() {
        return {
            guest: {},
            isDone: false,
        }
    },

    computed: {
        url() {
            return process.browser ? window.location.origin + `/users/${this.$route.params.username}/rsvp` : ''
        },

        showEmailBlock() {
            return this.model?.guest_form_template?.rsvp?.send_email
        },

        computedEvents() {
            return this.guest?.wedding_events?.length
                ? this.guest.wedding_events.filter((event) => event.status !== 0 && (!event.date || isBefore(new Date(), parseISO(event.date))))
                : []
        },
    },

    methods: {
        sendRsvp() {
            const hasUnAnsweredQuestions = this.computedEvents?.length
                ? this.computedEvents.some((event) => {
                      if (event.status === 3 && event.questions?.length) {
                          let answers = null
                          try {
                              answers = JSON.parse(event.answers)
                          } catch (error) {
                              answers = event.answers?.length || null
                          }

                          return (
                              answers.filter((answer) => answer.answer && !answer.is_optional).length !==
                              event.questions.filter((question) => !question.is_optional).length
                          )
                      }
                      return false
                  })
                : true

            if (process.browser) {
                const scrollElement = document.getElementsByTagName('main')

                if (hasUnAnsweredQuestions) {
                    this.$toast.error('You have to answer the required questions').goAway(3000)
                    if (process.browser) {
                        const element = document.querySelector('input[required]')
                        if (element && !element.value) if (scrollElement) scrollElement[0].scrollTop = element.offsetTop - 100
                    }
                } else {
                    this.isDone = true
                    scrollElement[0].scrollTop = 100
                }
            }
        },
    },
}
